<template>
  <div class="wrapperddiv">
    <el-card class="box-card">
		<el-row  type="flex" justify="end" >
			<el-button-group>
			<el-button type="danger" @click="delSelectDialogVisible=true">区间批量删除</el-button>
			</el-button-group>
			<el-upload
			    class="upload-demo"
			    action=""
			    :on-change="handleChangePt"
			    :show-file-list="false"
			    :auto-upload="false">
			    <el-button  type="primary" >导入excel文件</el-button>
			  </el-upload>
			<el-upload
			    class="upload-demo"
			    action=""
			    :on-change="handleChange"
			    :show-file-list="false"
			    :auto-upload="false">
			    <el-button  type="primary" >导入excel文件(+130,+2000,+3000KGS)</el-button>
			  </el-upload>
			<el-button-group>
		<!-- 	<el-button type="primary" @click="exportTableData">导出表格数据</el-button>
			<el-button type="primary" @click="exportSelectData">导出选中的行数据</el-button> -->
			</el-button-group>
			</el-row>
			<el-divider></el-divider>
		<el-row :gutter="20">
			<el-col :span="2">
				<el-button type="text" style="color: black;">起运港:</el-button>
			</el-col>
				<el-col :span="6">
					<el-select v-model="queryInfo.pol" filterable placeholder="请选择" clearable>
					  <el-option
					    v-for="item in polList"
					    :key="item.pol"
					    :label="item.pol"
					    :value="item.pol">
					  </el-option>
					</el-select>
					</el-col>
					<el-col :span="2">
						<el-button type="text" style="color: black;">目的港:</el-button>
					</el-col>
						<el-col :span="6">
							<el-select v-model="queryInfo.pod" filterable placeholder="请选择" clearable>
							  <el-option
							    v-for="item in podList"
							    :key="item.pod"
							    :label="item.pod"
							    :value="item.pod">
							  </el-option>
							</el-select>
							</el-col>
							<el-col :span="2">
								<el-button type="text" style="color: black;">国家:</el-button>
							</el-col>
								<el-col :span="6">
									<el-select v-model="queryInfo.country" filterable placeholder="请选择" clearable>
									  <el-option
									    v-for="item in countryList"
									    :key="item.country"
									    :label="item.country"
									    :value="item.country">
									  </el-option>
									</el-select>
									</el-col>
		</el-row>
		<el-row :gutter="20" style="margin-top: 20px;">
			<el-col :span="2">
				<el-button type="text" style="color: black;">航空公司:</el-button>
			</el-col>
				<el-col :span="6">
					<el-select v-model="queryInfo.carrier" filterable placeholder="请选择" clearable>
					  <el-option
					    v-for="item in carrierList"
					    :key="item.carrier"
					    :label="item.carrier"
					    :value="item.carrier">
					  </el-option>
					</el-select>
					</el-col>
			<el-col :span="2">
				<el-button type="text" style="color: black;">更新日期:</el-button>
			</el-col>
			<el-col :span="8">
			<el-date-picker
			  v-model="queryInfo.Sxvalue"
			  type="datetimerange"
			  :picker-options="pickerOptions"
			  range-separator="至"
			  start-placeholder="开始日期"
			  end-placeholder="结束日期"
			  align="right"
			  unlink-panels
			 :clearable="false"
			  >
			</el-date-picker>
			</el-col>
			<el-col :span="2">
				<el-button type="primary" @click="this.initListFn">查询</el-button>
			</el-col>
		</el-row>
	<el-divider></el-divider>
      <div slot="header" class="clearfix header-box">
        <span>空运</span>
      </div>
      <!-- 表格区域 -->
      <el-table
	  v-loading="loading"
	  element-loading-text="拼命加载中"
	  element-loading-spinner="el-icon-loading"
	  element-loading-background="rgba(0, 0, 0, 0.8)"
	  style="width: 100%" 
	  :data="dataList" 
	  border 
	  stripe 
	  ref="tableDataRef"
	  row-key="id"
	 :header-cell-style="{ 'background':'#F5F7FA','color':'#000000','text-align':'center' }"
	  @selection-change="handleSelectionChange">
	  <el-table-column
	    type="selection"
	  	  :reserve-selection="true"
	        width="55">
	      </el-table-column>
        <el-table-column
          label="序号"
          type="index"
        >
		</el-table-column>
		<el-table-column label="ID" prop="id"></el-table-column>
		<el-table-column label="AIR_ID" prop="air_id"></el-table-column>
		<el-table-column label="AIR_ID_TABLE" prop="air_id_table" width="150px"></el-table-column>
		<el-table-column label="加价" prop="add_price" width="150px"></el-table-column>
		<el-table-column label="起运港" prop="pol" width="150px"></el-table-column>
		<el-table-column label="目的港" prop="pod" width="150px"></el-table-column>
		<el-table-column label="国家" prop="country" width="150px"></el-table-column>
		
		<el-table-column label="航班日期" prop="etd"></el-table-column>
		<el-table-column label="航空公司" prop="carrier" width="150px"></el-table-column>
		<el-table-column label="有效日期" prop="yxq" width="160px"></el-table-column>
		<el-table-column label="货比" prop="cbm_kgs" width="150px"></el-table-column>
		<!-- T0 -->
		<el-table-column label="+45KGS(T0)">
		<el-table-column label="散货" prop="bulk_45_t0"></el-table-column>
		<el-table-column label="托盘" prop="tray_45_t0"></el-table-column>	
		</el-table-column>
		<el-table-column label="+100KGS(T0)">
		<el-table-column label="散货" prop="bulk_100_t0"></el-table-column>
		<el-table-column label="托盘" prop="tray_100_t0"></el-table-column>	
		</el-table-column>
		<el-table-column label="+130KGS(T0)">
		<el-table-column label="散货" prop="bulk_130_t0"></el-table-column>
		<el-table-column label="托盘" prop="tray_130_t0"></el-table-column>	
		</el-table-column>
		<el-table-column label="+300KGS(T0)">
		<el-table-column label="散货" prop="bulk_300_t0"></el-table-column>
		<el-table-column label="托盘" prop="tray_300_t0"></el-table-column>	
		</el-table-column>
		<el-table-column label="+500KGS(T0)">
		<el-table-column label="散货" prop="bulk_500_t0"></el-table-column>
		<el-table-column label="托盘" prop="tray_500_t0"></el-table-column>	
		</el-table-column>
		<el-table-column label="+1000KGS(T0)">
		<el-table-column label="散货" prop="bulk_1000_t0"></el-table-column>
		<el-table-column label="托盘" prop="tray_1000_t0"></el-table-column>	
		</el-table-column>
		<el-table-column label="+2000KGS(T0)">
		<el-table-column label="散货" prop="bulk_2000_t0"></el-table-column>
		<el-table-column label="托盘" prop="tray_2000_t0"></el-table-column>	
		</el-table-column>
		<el-table-column label="+3000KGS(T0)">
		<el-table-column label="散货" prop="bulk_3000_t0"></el-table-column>
		<el-table-column label="托盘" prop="tray_3000_t0"></el-table-column>	
		</el-table-column>
		<!-- T1 -->
		<el-table-column label="+45KGS(T1)">
		<el-table-column label="散货" prop="bulk_45_t1"></el-table-column>
		<el-table-column label="托盘" prop="tray_45_t1"></el-table-column>	
		</el-table-column>
		<el-table-column label="+100KGS(T1)">
		<el-table-column label="散货" prop="bulk_100_t1"></el-table-column>
		<el-table-column label="托盘" prop="tray_100_t1"></el-table-column>	
		</el-table-column>
		<el-table-column label="+130KGS(T1)">
		<el-table-column label="散货" prop="bulk_130_t1"></el-table-column>
		<el-table-column label="托盘" prop="tray_130_t1"></el-table-column>	
		</el-table-column>
		<el-table-column label="+300KGS(T1)">
		<el-table-column label="散货" prop="bulk_300_t1"></el-table-column>
		<el-table-column label="托盘" prop="tray_300_t1"></el-table-column>	
		</el-table-column>
		<el-table-column label="+500KGS(T1)">
		<el-table-column label="散货" prop="bulk_500_t1"></el-table-column>
		<el-table-column label="托盘" prop="tray_500_t1"></el-table-column>	
		</el-table-column>
		<el-table-column label="+1000KGS(T1)">
		<el-table-column label="散货" prop="bulk_1000_t1"></el-table-column>
		<el-table-column label="托盘" prop="tray_1000_t1"></el-table-column>	
		</el-table-column>
		<el-table-column label="+2000KGS(T1)">
		<el-table-column label="散货" prop="bulk_2000_t1"></el-table-column>
		<el-table-column label="托盘" prop="tray_2000_t1"></el-table-column>	
		</el-table-column>
		<el-table-column label="+3000KGS(T1)">
		<el-table-column label="散货" prop="bulk_3000_t1"></el-table-column>
		<el-table-column label="托盘" prop="tray_3000_t1"></el-table-column>	
		</el-table-column>
		<!-- T2 -->
		<el-table-column label="+45KGS(T2)">
		<el-table-column label="散货" prop="bulk_45_t2"></el-table-column>
		<el-table-column label="托盘" prop="tray_45_t2"></el-table-column>	
		</el-table-column>
		<el-table-column label="+100KGS(T2)">
		<el-table-column label="散货" prop="bulk_100_t2"></el-table-column>
		<el-table-column label="托盘" prop="tray_100_t2"></el-table-column>	
		</el-table-column>
		<el-table-column label="+130KGS(T2)">
		<el-table-column label="散货" prop="bulk_130_t2"></el-table-column>
		<el-table-column label="托盘" prop="tray_130_t2"></el-table-column>	
		</el-table-column>
		<el-table-column label="+300KGS(T2)">
		<el-table-column label="散货" prop="bulk_300_t2"></el-table-column>
		<el-table-column label="托盘" prop="tray_300_t2"></el-table-column>	
		</el-table-column>
		<el-table-column label="+500KGS(T2)">
		<el-table-column label="散货" prop="bulk_500_t2"></el-table-column>
		<el-table-column label="托盘" prop="tray_500_t2"></el-table-column>	
		</el-table-column>
		<el-table-column label="+1000KGS(T2)">
		<el-table-column label="散货" prop="bulk_1000_t2"></el-table-column>
		<el-table-column label="托盘" prop="tray_1000_t2"></el-table-column>	
		</el-table-column>
		<el-table-column label="+2000KGS(T2)">
		<el-table-column label="散货" prop="bulk_2000_t2"></el-table-column>
		<el-table-column label="托盘" prop="tray_2000_t2"></el-table-column>	
		</el-table-column>
		<el-table-column label="+3000KGS(T2)">
		<el-table-column label="散货" prop="bulk_3000_t2"></el-table-column>
		<el-table-column label="托盘" prop="tray_3000_t2"></el-table-column>	
		</el-table-column>
		<el-table-column label="中转港" prop="via" width="150px"></el-table-column>
		<el-table-column label="预计时效" prop="t_t" width="150px"></el-table-column>
		<el-table-column label="路径" prop="path" width="150px" :show-overflow-tooltip="true"></el-table-column>
		<el-table-column label="备注" prop="remark" width="150px"  :show-overflow-tooltip="true"></el-table-column>
				<el-table-column label="更新日期" prop="valid_fm" width="150px"></el-table-column>
        <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
                <el-button type="danger" size="mini" @click="removeFn(scope.row.id)">删除</el-button>
            </template>
        </el-table-column>
      </el-table>
	  <!-- 分页区域 -->
	  			<el-pagination 
	  			@size-change="handleSizeChange" 
	  			@current-change="handleCurrentChange"
	  			:current-page="queryInfo.pagenum" 
	  			:page-sizes="[10, 50, 100, 200]" 
	  			:page-size="queryInfo.pagesize"
	  			layout="total, sizes, prev, pager, next, jumper" :total="total">
	  			</el-pagination>
    </el-card>
	
	<el-dialog
	:lock-scroll="false" 
	title="区间批量删除" 
	:visible.sync="delSelectDialogVisible" 
	width="50%"
	@close="delSelectDialogClosed" 
	:close-on-click-modal="false">
		<el-form 
		ref="delSelectFormRef" 
		:model="delSelectForm" 
		label-width="100px">
		<el-row :gutter="20">
			<el-col :span="2">
				<el-button type="text" style="color: black;">选择ID区间:</el-button>
			</el-col>
			<el-col :span="9">
				<el-form-item  prop="start">
					<el-input v-model="delSelectForm.start"  type="number"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="1">
				<el-button type="text" style="color: black;">到</el-button>
			</el-col>
			<el-col :span="9"  style="margin-left: -95px;">
				<el-form-item  prop="end">
					<el-input v-model="delSelectForm.end" type="number" ></el-input>
				</el-form-item>
			</el-col>
		</el-row>
		</el-form>
		<span slot="footer" class="dialog-footer">
				<el-button @click="delSelectDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="delSelectConfirm">确 定</el-button>
			</span>
		</el-dialog>
	
  </div>
</template>

<script>
//表格导入依赖
import XLSX from 'xlsx'
import moment from 'moment';
export default {
  data () {
    return {
		podList:[],
		polList:[],
		countryList:[],
		carrierList:[],
		loading:false,
		fileContent: '',
		file: '',
		data: '',
		//+130，+2000，+3000
		fileContentMore: '',
		fileMore: '',
		dataMore:'',
		
		//选中行导出的值
		selectionList:[],
		multipleSelection:[],
		queryInfo: {
			country:'',
			Sxvalue:[new Date(Date.now() - 365*24*60*60*1000),new Date(Date.now() + 365*24*60*60*1000)],
			pol:'',
			pod:'',
			carrier:'',
			//当前的页数
			pagenum: 1,
			//当前每页显示多少条数据
			pagesize: 10,
		},
		total: 0,
		//日期
		pickerOptions: {
		         shortcuts: [{
		           text: '最近一周',
		           onClick(picker) {
		             const end = new Date();
		             const start = new Date();
		             start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
		             picker.$emit('pick', [start, end]);
		           }
		         }, {
		           text: '最近一个月',
		           onClick(picker) {
		             const end = new Date();
		             const start = new Date();
		             start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
		             picker.$emit('pick', [start, end]);
		           }
		         }, {
		           text: '最近三个月',
		           onClick(picker) {
		             const end = new Date();
		             const start = new Date();
		             start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
		             picker.$emit('pick', [start, end]);
		           }
		         }]
		       },
	//延时器，防抖，防止用户频繁请求
	  timer:null,
      dataList: [], // 数据列表
	//区间批量删除
	delSelectDialogVisible:false,
	delSelectForm:{
		start:'',
		end:''
	},
    }
  },
  
  created () {
    this.initListFn()
  },
  methods: {
	  //导出表格数据
	   exportTableData () {
	        // 获取dom元素（2种方式）
	        let table = this.$refs.tableDataRef.$el
	        let sheet = XLSX.utils.table_to_sheet(table)
	        let book = XLSX.utils.book_new()
	        XLSX.utils.book_append_sheet(book, sheet, "sheet1")
	        XLSX.writeFile(book, `lclFreight.xls`)
	      },
	  	//导出行数据
	  	 //监听复选框选中的值
	  	 handleSelectionChange(val){
	  		            this.selectionList = val
						//console.log(this.selectionList)
	  	 				let arryVal = val.map((item)=>{
	  	 					return item.id
	  	 				})
	  	 				 this.multipleSelection = arryVal;
						 //console.log(this.multipleSelection)
	  	 			},
	  	    exportSelectData () {
	  	      // 对选择的表格数据处理：添加标题
	  	      let arr = this.selectionList.map(item => {
	  	        return {
	  				   ID:item.id,
					   起运港:item.pol,
						 目的港:item.pod,
						 国家:item.country,
					    ['体积价(T0)']: item.freight_cmb_T0,
						['重量价(T0)']:item.freight_ton_T0,
						['体积价(T1)']:item.freight_cmb_T1,
						['重量价(T1)']:item.freight_ton_T1,
						['体积价(T2)']:item.freight_cmb_T2,
						['重量价(T2)']:item.freight_ton_T2,
						截单日:item.close_date,
						开航日:item.etd,
						 中转港:item.via,
						 预计航程:item['t_t'],
						 生效日:item.valid_fm,
						 失效日:item.valid_to,
                         备注:item.remark,	   
	  	        }
	  	      })
	  	      // 将json数据变为sheet数据
	  	      // json_to_sheet: 将一个由对象组成的数组转成sheet；
	  	      let sheet = XLSX.utils.json_to_sheet(arr)
	  	      // 新建表格
	  	      let book = XLSX.utils.book_new()
	  	      // 在表格中插入一个sheet
	  	      XLSX.utils.book_append_sheet(book, sheet, "sheet1")
	  	      // 通过xlsx的writeFile方法将文件写入
	  	      XLSX.writeFile(book, `lclFreight.xls`)
	  	    },
	 
	  
	  //导入功能*****************************************************
	  //+130，+2000，+3000KGS
	  			// 核心部分代码(handleChange 和 importfile)
	  			handleChange (file, fileList) {
	  			  this.fileContent = file.raw
	  			  const fileName = file.name
	  			  const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
				  if(file.size / 1024 /1024 > 2){
				  return	this.$message({
				  		type: 'warning',
				  		message: '该文件大小不能超过2MB,请检查ID是否异常溢出！'
				  	})
				  }
				  
	  			    if (this.fileContent) {
	  			      if (fileType === 'xlsx' || fileType === 'xls') {
	  			        this.importfile(this.fileContent)
	  			      } else {
	  			        this.$message({
	  			          type: 'warning',
	  			          message: '附件格式错误，请重新上传！'
	  			        })
	  			      }
	  			    } else {
	  			      this.$message({
	  			        type: 'warning',
	  			        message: '请上传附件！'
	  			      })
	  			    }
	  			  },
	  			 importfile (obj) {
	  			   const reader = new FileReader()
	  			   const _this = this
	  			   reader.readAsArrayBuffer(obj)
	  			   reader.onload = async function(){
	  			     const buffer = reader.result
	  			     const bytes = new Uint8Array(buffer)
	  			     const length = bytes.byteLength
	  			     let binary = ''
	  			     for (let i = 0; i < length; i++) {
	  			       binary += String.fromCharCode(bytes[i])
	  			     }
	  			      const XLSX = require('xlsx')
	  			      const wb = XLSX.read(binary, {
	  			        type: 'binary',
						cellDates: true
	  			      })
	  			      const outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]])
					  console.log(outdata)
	  			      this.data = [...outdata].slice(1)
					 console.log(this.data)
					 console.log(this.data[0]['+130KGS(T0)'])
					 if(this.data[0]['+130KGS(T0)'] ==undefined){
					 	return _this.$message.error('表格缺少+130,+2000,+3000KGS价格') 
					 }
					 //判断有效期，日期错误提醒
					  //console.log(this.data)
					  let index = this.data.findIndex(item => new Date(item['有效日期'] ? item['有效日期'].split('至')[0] : '').getTime() > new Date(item['有效日期'] ? item['有效日期'].split('至')[1] : '').getTime())
					  //console.log(index)
					  if(index !=-1){
					 	return _this.$message.error(`ID为${this.data[index]['ID']}的有效日期错误！`)
					 	
					  }
	  			      const arr = []
	  			      this.data.map (v => {
	  			        const obj ={}
	  			          obj.id = v['ID']
						  obj.air_id = v['AIR_ID']
						  obj.air_id_table = v['AIR_ID_TABLE']
						  obj.add_price = v['加价']
						  obj.pol = v['起运港']
						  obj.pod = v['目的港']
						  obj.country = v['国家']
						  obj.etd = v['航班日期']
						  obj.carrier = v['航空公司']
						  obj.yxq =  v['有效日期']
						  obj.cbm_kgs = v['货比']
						  //T0
						  obj['bulk_45_t0'] = v['+45KGS(T0)']
						  obj['tray_45_t0'] = v['__EMPTY']
						  obj['bulk_100_t0'] = v['+100KGS(T0)']
						  obj['tray_100_t0'] = v['__EMPTY_1']
						  obj['bulk_130_t0'] = v['+130KGS(T0)']
						  obj['tray_130_t0'] = v['__EMPTY_2']
						  obj['bulk_300_t0'] = v['+300KGS(T0)']
						  obj['tray_300_t0'] = v['__EMPTY_3']
						  obj['bulk_500_t0'] = v['+500KGS(T0)']
						  obj['tray_500_t0'] = v['__EMPTY_4']
						  obj['bulk_1000_t0'] = v['+1000KGS(T0)']
						  obj['tray_1000_t0'] = v['__EMPTY_5']
						  obj['bulk_2000_t0'] = v['+2000KGS(T0)']
						  obj['tray_2000_t0'] = v['__EMPTY_6']
						  obj['bulk_3000_t0'] = v['+3000KGS(T0)']
						  obj['tray_3000_t0'] = v['__EMPTY_7']
						  //T1
						  obj['bulk_45_t1'] = v['+45KGS(T1)']
						  obj['tray_45_t1'] = v['__EMPTY_8']
						  obj['bulk_100_t1'] = v['+100KGS(T1)']
						  obj['tray_100_t1'] = v['__EMPTY_9']
						  obj['bulk_130_t1'] = v['+130KGS(T1)']
						  obj['tray_130_t1'] = v['__EMPTY_10']
						  obj['bulk_300_t1'] = v['+300KGS(T1)']
						  obj['tray_300_t1'] = v['__EMPTY_11']
						  obj['bulk_500_t1'] = v['+500KGS(T1)']
						  obj['tray_500_t1'] = v['__EMPTY_12']
						  obj['bulk_1000_t1'] = v['+1000KGS(T1)']
						  obj['tray_1000_t1'] = v['__EMPTY_13']
						  obj['bulk_2000_t1'] = v['+2000KGS(T1)']
						  obj['tray_2000_t1'] = v['__EMPTY_14']
						  obj['bulk_3000_t1'] = v['+3000KGS(T1)']
						  obj['tray_3000_t1'] = v['__EMPTY_15']
						  //T2
						  obj['bulk_45_t2'] = v['+45KGS(T2)']
						  obj['tray_45_t2'] = v['__EMPTY_16']
						  obj['bulk_100_t2'] = v['+100KGS(T2)']
						  obj['tray_100_t2'] = v['__EMPTY_17']
						  obj['bulk_130_t2'] = v['+130KGS(T2)']
						  obj['tray_130_t2'] = v['__EMPTY_18']
						  obj['bulk_300_t2'] = v['+300KGS(T2)']
						  obj['tray_300_t2'] = v['__EMPTY_19']
						  obj['bulk_500_t2'] = v['+500KGS(T2)']
						  obj['tray_500_t2'] = v['__EMPTY_20']
						  obj['bulk_1000_t2'] = v['+1000KGS(T2)']
						  obj['tray_1000_t2'] = v['__EMPTY_21']
						  obj['bulk_2000_t2'] = v['+2000KGS(T2)']
						  obj['tray_2000_t2'] = v['__EMPTY_22']
						  obj['bulk_3000_t2'] = v['+3000KGS(T2)']
						  obj['tray_3000_t2'] = v['__EMPTY_23']
						  obj.via = v['中转港']
						  obj['t_t'] = v['预计时效']
						  obj.valid_fm = v['更新日期'] = moment(v['更新日期']).format('YYYY-MM-DD')
						  obj.path = v['路径']
						  obj.remark = v['备注']
	  					//console.log(obj)
	               arr.push(obj)
	  			      })
					 // console.log(arr)
	  				 // //后端请求数据
	  				 // //这里不能用this，用_this
					 //数据格式化数组对象转成(),(),()
					 let str = arr.reduce((total,item,index)=>{
						 //累加三个逗号
					     if(index!=0){total+=','}
					     total+='("'+ encodeURIComponent(Object.values(item).join('","'))  +'")'
					     return total
					 },"")
					 
					 
					   let datainfo={
						   infoString:decodeURIComponent(str)
					   }
					 
					 const {data: res} = await _this.$http.addMoreByAir({data:datainfo})	
					 if (res.status !== 0) {
					 	return _this.$message.error(res.message)
					 }

					_this.$message.success('导入成功！')
				   setTimeout(() => {
				   	window.location.reload()
				        }, 500);
	  			    }
	  			  },
		//导入普通*******************************************		  
		handleChangePt (file, fileList) {
		  this.fileContentMore = file.raw
		  const fileName = file.name
		  const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
			if(file.size / 1024 /1024 > 2){
			return	this.$message({
					type: 'warning',
					message: '该文件大小不能超过2MB,请检查ID是否异常溢出！'
				})
			}
			
		    if (this.fileContentMore) {
		      if (fileType === 'xlsx' || fileType === 'xls') {
		        this.importfileMore(this.fileContentMore)
		      } else {
		        this.$message({
		          type: 'warning',
		          message: '附件格式错误，请重新上传！'
		        })
		      }
		    } else {
		      this.$message({
		        type: 'warning',
		        message: '请上传附件！'
		      })
		    }
		  },
		 importfileMore (obj) {
		   const reader = new FileReader()
		   const _this = this
		   reader.readAsArrayBuffer(obj)
		   reader.onload = async function(){
		     const buffer = reader.result
		     const bytes = new Uint8Array(buffer)
		     const length = bytes.byteLength
		     let binary = ''
		     for (let i = 0; i < length; i++) {
		       binary += String.fromCharCode(bytes[i])
		     }
		      const XLSX = require('xlsx')
		      const wb = XLSX.read(binary, {
		        type: 'binary',
				cellDates: true
		      })
		      const outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]])
			  console.log(outdata)
		      this.dataMore = [...outdata].slice(1)
					//判断只能导入普通表格
			 //console.log(this.dataMore[0]['+130KGS(T0)'])
			 if(this.dataMore[0]['+130KGS(T0)'] !==undefined){
				return _this.$message.error('表格不能含有+130,+2000,+3000KGS价格') 
			 }
			 //判断有效期，日期错误提醒
			 //console.log(this.dataMore)
			 let index = this.dataMore.findIndex(item => new Date(item['有效日期'] ? item['有效日期'].split('至')[0] : '').getTime() > new Date(item['有效日期'] ? item['有效日期'].split('至')[1] : '').getTime())
			 //console.log(index)
			 if(index !=-1){
				return _this.$message.error(`ID为${this.dataMore[index]['ID']}的有效日期错误！`)
				
			 }
			 
		      const arr = []
		      this.dataMore.map (v => {
		        const obj ={}
		          obj.id = v['ID']
				  obj.air_id = v['AIR_ID']
				  obj.air_id_table = v['AIR_ID_TABLE']
				  obj.add_price = v['加价']
				  obj.pol = v['起运港']
				  obj.pod = v['目的港']
				  obj.country = v['国家']
				  obj.etd = v['航班日期']
				  obj.carrier = v['航空公司']
				  obj.yxq =  v['有效日期']
				  obj.cbm_kgs = v['货比']
				  //T0
				  obj['bulk_45_t0'] = v['+45KGS(T0)']
				  obj['tray_45_t0'] = v['__EMPTY']
				  obj['bulk_100_t0'] = v['+100KGS(T0)']
				  obj['tray_100_t0'] = v['__EMPTY_1']
				  obj['bulk_300_t0'] = v['+300KGS(T0)']
				  obj['tray_300_t0'] = v['__EMPTY_2']
				  obj['bulk_500_t0'] = v['+500KGS(T0)']
				  obj['tray_500_t0'] = v['__EMPTY_3']
				  obj['bulk_1000_t0'] = v['+1000KGS(T0)']
				  obj['tray_1000_t0'] = v['__EMPTY_4']
				  //T1
				  obj['bulk_45_t1'] = v['+45KGS(T1)']
				  obj['tray_45_t1'] = v['__EMPTY_5']
				  obj['bulk_100_t1'] = v['+100KGS(T1)']
				  obj['tray_100_t1'] = v['__EMPTY_6']
				  obj['bulk_300_t1'] = v['+300KGS(T1)']
				  obj['tray_300_t1'] = v['__EMPTY_7']
				  obj['bulk_500_t1'] = v['+500KGS(T1)']
				  obj['tray_500_t1'] = v['__EMPTY_8']
				  obj['bulk_1000_t1'] = v['+1000KGS(T1)']
				  obj['tray_1000_t1'] = v['__EMPTY_9']
				  //T2
				  obj['bulk_45_t2'] = v['+45KGS(T2)']
				  obj['tray_45_t2'] = v['__EMPTY_10']
				  obj['bulk_100_t2'] = v['+100KGS(T2)']
				  obj['tray_100_t2'] = v['__EMPTY_11']
				  obj['bulk_300_t2'] = v['+300KGS(T2)']
				  obj['tray_300_t2'] = v['__EMPTY_12']
				  obj['bulk_500_t2'] = v['+500KGS(T2)']
				  obj['tray_500_t2'] = v['__EMPTY_13']
				  obj['bulk_1000_t2'] = v['+1000KGS(T2)']
				  obj['tray_1000_t2'] = v['__EMPTY_14']
				  obj.via = v['中转港']
				  obj['t_t'] = v['预计时效']
				  obj.valid_fm = v['更新日期'] = moment(v['更新日期']).format('YYYY-MM-DD')
				  obj.path = v['路径']
				  obj.remark = v['备注']
				//console.log(obj)
		   arr.push(obj)
		      })
			 // console.log(arr)
			 // //后端请求数据
			 // //这里不能用this，用_this
			 //数据格式化数组对象转成(),(),()
			 let str = arr.reduce((total,item,index)=>{
				 //累加三个逗号
			     if(index!=0){total+=','}
			     total+='("'+ encodeURIComponent(Object.values(item).join('","'))  +'")'
			     return total
			 },"")
			   let datainfo={
				   infoString:decodeURIComponent(str)
			   }
		
			 const {data: res} = await _this.$http.addMoreByAirPt({data:datainfo})	
			 if (res.status !== 0) {
			 	return _this.$message.error(res.message)
			 }
		
			_this.$message.success('导入成功！')
		   setTimeout(() => {
		   	window.location.reload()
		        }, 500);
		    }
		  },		  
				  
				  
				  
				  
				  
				  
				  
				  
				  
				  
				  
				  
				  
				  
	  changeValue(e) {
	              this.queryInfo.pagenum = 1
	  clearTimeout(this.timer)
	          this.timer = setTimeout(()=>{
	          		this.queryInfo.query = e
	          		 console.log(this.queryInfo.query)
	          		this.initListFn()
	  
	          	},500)
	         },
	  // 获取列表；获取下拉数据也获取所有列表数据
	  async initListFn () {
		  this.loading = true
	    const {data:res} = await this.$http.getByAir({params:this.queryInfo})
			if (res.status !==0){
			 return this.$message.error('获取数据失败!')
			}
	      this.dataList = res.data
				//console.log(this.dataList)
		  this.total = res.total
		  this.loading = false
		  this.podList = res.pod
		  this.polList = res.pol
		  this.countryList = res.country
		  this.carrierList = res.carrier
		  
		  
	  },
	  //监听pagesize改变的事件
	  handleSizeChange(newSize) {
	  	this.queryInfo.pagesize = newSize
	  	this.initListFn()
	  },
	  //监听页面值改变的事件
	  handleCurrentChange(newPage) {
	  	this.queryInfo.pagenum = newPage
	  	this.initListFn()
	  },
    // 删除
    async removeFn (id) {
		const confirmResult = await this.$confirm('此操作将删除这条数据是否继续?', '提示', {
		  confirmButtonText: '确定',
		  cancelButtonText: '取消',
		  type: 'warning',
		   lockScroll:false
		}).catch(err => err)
		if (confirmResult !== 'confirm'){
			return this.$message.info('已取消删除')
		}
		const { data: res } = await this.$http.delByAir(id)
		if (res.status!== 0) return this.$message.error('删除失败！')
		this.$message.success('删除成功！')
		// 重新请求列表数据
		this.initListFn()
		
    },
	
	
	//区间删除
	async delSelectConfirm(){
		if (this.delSelectForm.start == '' && this.delSelectForm.end == '') {
			return this.$message.warning('请填写ID！')
		}
		const confirmResult = await this.$confirm('注意！此操作将批量删除, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning',
			lockScroll:false
		}).catch(err => err)
		//如果确认删除，则返回值为字符串 confirm
		console.log(confirmResult)
		if (confirmResult !== 'confirm') {
			return this.$message.info('已取消删除')
		}
		let idString = `${this.delSelectForm.start},${this.delSelectForm.end}`
		const {
			data: res
		} = await this.$http.delBatchByAir({
			id: idString
		})
		if (res.status !== 0) {
			return this.$message.error('批量删除失败!')
		}
		this.$message.success('批量删除成功!')
		this.initListFn()
		this.delSelectDialogVisible = false
		},
		delSelectDialogClosed(){
			this.$refs.delSelectFormRef.resetFields()
		}

	    
  }
}
</script>

<style lang="less" scoped>
.header-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media screen and (min-width: 1280px) {
		.wrapperddiv{
			height: 100vh;
			width: 100%;
			display:inline-block;
		} 
	}
	
	//手机端
	@media screen and (max-width: 1280px) {
		.wrapperddiv{
			height: 100%;
			width: 100%;
			display:inline-block;
		} 
	}
</style>
